<template>
  <date-picker
    style="width: 100%"
    prefix-class="xmx"
    v-bind="{ ...$props, ...$attrs }"
    v-model="datetime"
    :valueType="dateFormat"
    :input-class="[ error ? 'form-control is-invalid' : 'form-control' ]"
    :format="dateFormat"
    :type="type"
  >
    <i slot="icon-calendar">
        <i class="calendar--icon"></i>
    </i>
    <i slot="icon-clear">
        <i class="icon-close" style="font-size: 24px"></i>
    </i>
  </date-picker>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "./datepicker.scss";
import "vue2-datepicker/locale/de";

export default {
  components: { DatePicker },
  props: {
    error: Boolean,
    value: [String, Number, Date],
    format: String,
    type: String,
  }, 
  data() {
    return {
      datetime: this.value,
      dateFormat: this.format ?? 'YYYY-MM-DD',
    };
  },
  
  watch: {
    datetime() {
      this.$emit("input", this.datetime);
    },
  },
};
</script>

<style scoped>
</style>
